var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 6 21",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07595 8.15644C4.27632 8.15644 5.23662 9.13205 5.23662 10.3516C5.23662 11.5711 4.27632 12.5467 3.07595 12.5467C1.87558 12.5467 0.915283 11.5711 0.915283 10.3516C0.915283 9.13205 1.87558 8.15644 3.07595 8.15644ZM0.915283 2.54668C0.915283 3.7662 1.87558 4.74181 3.07595 4.74181C4.27632 4.74181 5.23662 3.7662 5.23662 2.54668C5.23662 1.32717 4.27632 0.351563 3.07595 0.351562C1.87558 0.351562 0.915283 1.32717 0.915283 2.54668ZM0.915283 18.1564C0.915283 19.376 1.87558 20.3516 3.07595 20.3516C4.27632 20.3516 5.23662 19.376 5.23662 18.1564C5.23662 16.9369 4.27632 15.9613 3.07595 15.9613C1.87558 15.9613 0.915283 16.9369 0.915283 18.1564Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.d824520c.svg";
export { ForwardRef as ReactComponent };